import { useState, useEffect } from "react";
import { GetBackgroundPositionCoordinates } from "Helpers/ImageHelper/ImageHelper";

export const useFocalPoint = (image) => {
	const [coordinates, setCoordinates] = useState({});
	const [isCropped, setIsCropped] = useState(false);
	useEffect(() => {
		const bgPositionCoordinats = GetBackgroundPositionCoordinates(image);
		const { mode } = bgPositionCoordinats;
		setCoordinates(bgPositionCoordinats);
		setIsCropped(mode != undefined && !!mode.length);
	}, []);

	return { isCropped, coordinates };
};

export default useFocalPoint;
